import { createRouter, createWebHistory } from "vue-router";
import Login from "@/components/LoginUser.vue";
import Status from "@/components/StatusUser.vue";

const routes = [
  {
    path: "/",
    name: "Home",
    component: Login,
  },
  {
    path: "/login",
    name: "Login",
    component: Login, // ใช้ Component เดียวกัน
  },
  {
    // Self-service registration is gone: a WiFi account is now provisioned
    // automatically after OTP verification, and only for existing WashXpress
    // customers. Old bookmarks and the Mikrotik pages land back on login.
    path: "/register",
    redirect: { name: "Home" },
  },
  {
    path: "/status",
    name: "Status",
    component: Status,
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: { name: "Home" },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
